export const menuItemsData = [
  {
    title: "Home",
    url: "/",
  },
  {
    title: "Umrah Packages",
    url: "/packages/Umrah",
    submenu: [
        {
          title: "July Umrah Package",
          url: "/umrah/july-umrah-package",
        },
      {
        title: "August Umrah Package",
        url: "/umrah/august-umrah-package",
      },
      {
        title: "September Umrah Package",
        url: "/umrah/september-umrah-package",
      },
      {
        title: "October Umrah Package",
        url: "/umrah/october-umrah-package",
      },
      {
        title: "November  Umrah Package",
        url: "/umrah/november-umrah-package",
      },
      {
        title: "December Umrah Package",
        url: "/umrah/december-umrah-package",
      },
    //   {
    //     title: "Standard Packages",
    //     url: "",
    //     submenu: [
    //       {
    //         title: "4 Days Umrah Package",
    //         url: "/packages/Umrah/standard-4-days-package",
    //       },
    //       {
    //         title: "6 Days Umrah Package",
    //         url: "/packages/Umrah/standard-6-days-package",
    //       },{
    //         title: "8 Days Umrah Package",
    //         url: "/packages/Umrah/standard-8-days-package",
    //       },
    //       {
    //         title: "10 Days Umrah Package",
    //         url: "/packages/Umrah/standard-10-days-package",
    //       },
    //     ],
    //   },
    //   {
    //     title: "Economy Packages",
    //     url: "",
    //     submenu: [
    //       {
    //         title: "4 Days Umrah Package",
    //         url: "/packages/Umrah/economy-4-days-package",
    //       },
    //       {
    //         title: "6 Days Umrah Package",
    //         url: "/packages/Umrah/economy-6-days-package",
    //       },{
    //         title: "8 Days Umrah Package",
    //         url: "/packages/Umrah/economy-8-days-package",
    //       },
    //       {
    //         title: "10 Days Umrah Package",
    //         url: "/packages/Umrah/economy-10-days-package",
    //       },
    //     ],
    //   },
    //   {
    //     title: "Premium Packages",
    //     submenu: [
    //       {
    //         title: "4 Days Umrah Package",
    //         url: "/packages/Umrah/premium-4-days-package",
    //       },
    //       {
    //         title: "6 Days Umrah Package",
    //         url: "/packages/Umrah/premium-6-days-package",
    //       },{
    //         title: "8 Days Umrah Package",
    //         url: "/packages/Umrah/premium-8-days-package",
    //       },
    //       {
    //         title: "10 Days Umrah Package",
    //         url: "/packages/Umrah/premium-10-days-package",
    //       },
    //     ],
    //
    //   },
    //   {
    //     title: "Luxury Packages",
    //     submenu: [
    //       {
    //         title: "4 Days Umrah Package",
    //         url: "/packages/Umrah/luxury-4-days-package",
    //       },
    //       {
    //         title: "6 Days Umrah Package",
    //         url: "/packages/Umrah/luxury-6-days-package",
    //       },{
    //         title: "8 Days Umrah Package",
    //         url: "/packages/Umrah/luxury-8-days-package",
    //       },
    //       {
    //         title: "10 Days Umrah Package",
    //         url: "/packages/Umrah/luxury-10-days-package",
    //       },
    //     ],
    //
    //   },
      // {
      //   title: "Ramadan Packages",
      //   submenu: [
      //     {
      //       title: "3 Days Umrah In Ramadan",
      //       url: "/packages/Umrah/3-Days-Umrah-Packages-in-Ramadan",
      //     },
      //     {
      //       title: "1st Ashrah In Ramadan",
      //       url:"/packages/Umrah/Umrah-in-Ramadan-1st-10-days"
      //     },
      //     {
      //       title: "2nd Ashrah In Ramadan",
      //       url:"/packages/Umrah/Umrah-in-Ramadan-2nd-10-days"
      //     },
      //     {
      //       title: "3rd Ashrah In Ramadan",
      //       url:"/packages/Umrah/Umrah-in-Ramadan-last-10-days"
      //     },
      //     {
      //       title: "Etikaaf Umrah In Ramadan",
      //       url:"/packages/Umrah/Etikaaf-Package"
      //     },
      //     {
      //       title: "Eid-ul-fitr In Haram",
      //       url:"/packages/Umrah/5-Days-of-Eid-ul-Fitar-in-Makkah-and-Madinah"
      //     },
      //   ],
      // },

    ],
  },
  {
    title: "Umrah From",
    url: "",
    submenu: [
      {title: "California", url: "/umrah-package-california"},
      {title: "Los Angeles", url: "/umrah-package-los-angeles"},
      {title: "Washington DC", url: "/umrah-package-washington-dc"},
      {title: "Newyork", url: "/umrah-package-newyork"},
      {title: "Colorado", url: "/umrah-package-colorado"},
      {title: "Michigan", url: "/umrah-package-michigan"},
      {title: "Houston", url: "/umrah-package-houston"},
      {title: "Atlanta GA", url: "/umrah-package-atlanta-ga"},
      {title: "Dallas", url: "/umrah-package-dallas"},
      {title: "Philadelphia", url: "/umrah-package-philadelphia"},
      {title: "Dearborn", url: "/umrah-package-dearborn"},
    ]
  },
  // {
  //   title: "Hajj Packages",
  //   url: "/packages/Hajj",
  //   // submenu: [
  //   //   {
  //   //     title: "Standard",
  //   //     url: "",
  //   //     submenu: [
  //   //       {
  //   //         title: "Standard 1",
  //   //         url: "",
  //   //       },
  //   //       {
  //   //         title: "Standard 2",
  //   //         url:""
  //   //       },
  //   //     ],
  //   //   },
  //   //   {
  //   //     title: "Gold",
  //   //     url: "",
  //   //     submenu: [
  //   //       {
  //   //         title: "Gold 1",
  //   //         url: "",
  //   //       },
  //   //       {
  //   //         title: "Gold 2",
  //   //         url:""
  //   //       },
  //   //     ],
  //   //   },
  //   //   {
  //   //     title: "Platanium",
  //   //     submenu: [
  //   //       {
  //   //         title: "Platanium 1",
  //   //         url: "",
  //   //       },
  //   //       {
  //   //         title: "Platanium 2",
  //   //         url:""
  //   //       },
  //   //     ],
  //   //   },
  //   // ],
  // },

  // {
  //   // title: "Tour Packages",
  //   // url: "/packages/Other",
  //   // submenu: [
  //   //   {
  //   //     title: "Standard",
  //   //     url: "",
  //   //     submenu: [
  //   //       {
  //   //         title: "Standard 1",
  //   //         url: "",
  //   //       },
  //   //       {
  //   //         title: "Standard 2",
  //   //         url:""
  //   //       },
  //   //     ],
  //   //   },
  //   //   {
  //   //     title: "Gold",
  //   //     url: "",
  //   //     submenu: [
  //   //       {
  //   //         title: "Gold 1",
  //   //         url: "",
  //   //       },
  //   //       {
  //   //         title: "Gold 2",
  //   //         url:""
  //   //       },
  //   //     ],
  //   //   },
  //   //   {
  //   //     title: "Platanium",
  //   //     submenu: [
  //   //       {
  //   //         title: "Platanium 1",
  //   //         url: "",
  //   //       },
  //   //       {
  //   //         title: "Platanium 2",
  //   //         url:""
  //   //       },
  //   //     ],
  //   //   },
  //   // ],
  // },
  {
    title: "Tour Packages",
    url: "/tour-packages",
  },
  // {
  //   title: "Blogs",
  //   url: "/blogs",
  // },
  // {
  //   title: "Nusuk Hajj",
  //   url: "/nusuk",
  // },
  // {
  //   title: "Mofa Services",
  //   url: "/10-year-saudi-visa",
  // },
  {
    title: "10 Year Saudi Visa",
    url: "/10-year-sauditourist-evisa",
  },
  {
    title: "Hajj 2026",
    url: "/hajj-package-2026",
  },
  // {
  //   title: "June 2025 Umrah Package",
  //   url: "/umrah/june-umrah-package",
  // },
  // {
  //   title: "Umrah Package Dallas",
  //   url: "/umrah-package-dallas",
  // },
  {
    title: "Contact Us",
    url: "/contactus",
  },

];
